<div class="filter-body {{ filterType }}-filter-body max-h-screen">
  <header class="filter-header" *ngIf="callFromDialog">
    <div class="flex items-baseline">
      <h2 class="!text-2xl modal-headline">{{ dialogHeader }}</h2>
      <div class="ml-auto">
        <button mat-icon-button mat-dialog-close class="button-close">
          <mat-icon class="material-icons-outlined" aria-hidden="true">close</mat-icon>
          <span class="sr-only" i18n>Close</span>
        </button>
      </div>
    </div>
  </header>

  <div class="options filter-main mt-3 overflow-auto" [ngClass]="className">
    <sp-loading-inprogress [showSpinner]="true" [diameter]="50" *ngIf="filterFormService.totalRequests !== 0; else loadFilters"></sp-loading-inprogress>
    <ng-template #loadFilters>
      <form action="" [formGroup]="filterForm">
        <fieldset class="field-section-group flex flex-wrap -m-2" (click)="$event.stopPropagation()">
          <ng-template ngFor let-field [ngForOf]="filterProjectFormData['formFields']" let-i="index">
            <div [ngSwitch]="field['fieldType']" class="field-box inline-block" [ngClass]="[field['widthClass'], !field.visible ? 'hidden' : '']">
              <div *ngSwitchCase="'text'" class="input-box mx-2 my-1">
                <span class="field-label" *ngIf="!field['hideLabel']">{{ field['fieldLabel'] }}</span>
                <mat-form-field appearance="outline" subscriptSizing="dynamic" color="primary" class="input-template template-name w-full">
                  <input autocomplete="off" matInput [type]="field['inputType']!" [name]="field['formFieldName']!" [formControlName]="field['formFieldName']!" [placeholder]="field['placeholder']" />
                </mat-form-field>
              </div>
              <div *ngSwitchCase="'duration'" class="input-box mx-2 my-1">
                <span class="field-label" *ngIf="!field['hideLabel']">{{ field['fieldLabel'] }}</span>
                <mat-form-field appearance="outline" subscriptSizing="dynamic" color="primary" class="input-template template-name w-full">
                  <input
                    autocomplete="off"
                    matInput
                    [type]="field['inputType']!"
                    [name]="field['formFieldName']!"
                    [formControlName]="field['formFieldName']!"
                    [placeholder]="field['placeholder']"
                    DurationPicker
                  />
                </mat-form-field>
              </div>
              <div class="mx-2 my-1" *ngSwitchCase="'dropdown'">
                <span class="field-label" *ngIf="!field['hideLabel']">{{ field['fieldLabel'] }}</span>
                <sp-mat-select-search
                  class="w-full"
                  [formControlName]="field['formFieldName']!"
                  [dataSource]="field['options']"
                  [placeholder]="field['placeholder']"
                  [subscriptSizing]="'dynamic'"
                  [disabledField]="field['disable'] || false"
                  [config]="{
                    search: true,
                    multiple: field['multiple'],
                    matDivider: field['matDivider'],
                    disableSingleSelect: true,
                    sortDataSource: field.sortDataSource,
                    enableSecondPartLabel: true,
                  }"
                  [attrDataTestId]="filterType + '-filter_' + field['formFieldName']"
                  (selectedChange)="onValueChange($event, field, field['formFieldName']!)"
                  (removeChip)="removeChip($event)"
                ></sp-mat-select-search>
              </div>
              <div *ngSwitchCase="'multiSelectChip'" class="mx-2 my-1">
                <span class="field-label" *ngIf="!field['hideLabel']">{{ field['fieldLabel'] }}</span>
                <sp-mat-select-search
                  class="w-full"
                  [formControlName]="field['formFieldName']"
                  [dataSource]="field['options'] || []"
                  [placeholder]="field['placeholder'] || ''"
                  [subscriptSizing]="'dynamic'"
                  [config]="{
                    search: true,
                    multiple: true,
                    sortDataSource: field.sortDataSource,
                    enableMatOptGroup: field.enableMatOptGroup ? field.enableMatOptGroup : false,
                  }"
                  (selectedChange)="onValueChange($event, field, field['formFieldName']!)"
                  (removeChip)="removeChip($event)"
                ></sp-mat-select-search>
              </div>
              <div *ngSwitchCase="'textarea'" class="input-box mx-2 my-1">
                <span class="field-label" *ngIf="!field['hideLabel']">{{ field['fieldLabel'] }}</span>
                <mat-form-field appearance="outline" color="primary" class="input-template template-name w-full">
                  <textarea matInput type="text" [name]="field['formFieldName']!" [formControlName]="field['formFieldName']!" [placeholder]="field['placeholder']"></textarea>
                </mat-form-field>
              </div>
              <div class="mx-2 my-1" *ngSwitchCase="'date'">
                <span class="field-label" *ngIf="!field['hideLabel']">{{ field['fieldLabel'] }}</span>
                <sp-date-picker
                  [formControlName]="field['formFieldName']!"
                  [placeholder]="field['placeholder']"
                  [dateCssClass]="'input-template template-name w-full'"
                  [fieldLabel]="field['fieldLabel']"
                  [subscriptSizing]="'dynamic'"
                ></sp-date-picker>
              </div>
              <div *ngSwitchCase="'label'" class="form-label ml-2 mt-2 font-bold">
                {{ field['fieldLabel'] }}
              </div>
              <div class="mx-2 my-1" *ngSwitchCase="'autocomplete'">
                <span class="field-label" *ngIf="!field['hideLabel']">{{ field['fieldLabel'] }}</span>
                <mat-form-field color="primary" class="input-template template-name w-full" appearance="outline">
                  <input type="text" [placeholder]="field['placeholder']" matInput [formControlName]="field['formFieldName']!" [matAutocomplete]="auto" />
                  <mat-autocomplete autoActiveFirstOption #auto="matAutocomplete">
                    <mat-option *ngFor="let option of field['options']" [value]="option.id">
                      {{ option.name }}
                    </mat-option>
                  </mat-autocomplete>
                </mat-form-field>
              </div>
              <div class="mt-2" *ngSwitchCase="'checkbox'">
                <mat-checkbox class="input-template template-name w-full mx-2 my-1" [formControlName]="field['formFieldName']" (change)="checkboxChanged($event, field['formFieldName'])">
                  <span class="field-label text-[#919394] font-bold" *ngIf="!field['hideLabel']">{{ field['fieldLabel'] }}</span>
                </mat-checkbox>
              </div>
              <div
                *ngIf="isGuidedTourEnabled && ['assetType', 'channel', 'subject'].includes(field['formFieldName'])"
                tourAnchor="vorwerk.asset-filter-facetted.anchor.combined"
                class="guided-tour-target absolute combined-anchor overlay-target"
              ></div>
              <div
                *ngIf="isGuidedTourEnabled && ['agency', 'client', 'brand'].includes(field['formFieldName'])"
                tourAnchor="vorwerk.asset-filter-iterative.anchor.combined"
                class="guided-tour-target absolute combined-anchor overlay-target"
              ></div>
            </div>
          </ng-template>
        </fieldset>
      </form>
    </ng-template>
  </div>

  <div class="filter-footer" [ngClass]="{ '!justify-end': callFromDialog }">
    <!-- Set of buttons showing on filter menu -->
    <button (click)="filterData()" mat-flat-button class="button-primary" *ngIf="!callFromDialog && !isCustomTab">
      <mat-icon class="material-icons-outlined">check</mat-icon>
      <span class="px-2 font-bold" i18n>Apply</span>
    </button>
    <button (click)="filterData()" mat-flat-button class="save-button button-primary" *ngIf="!callFromDialog && isCustomTab">
      <mat-icon class="material-icons-outlined">save</mat-icon>
      <span class="px-2 font-bold" i18n>Save</span>
    </button>
    <button (click)="addTabs()" mat-flat-button class="button-primary" *ngIf="!callFromDialog && ['project', 'task'].includes(filterType) && isCustomTab">
      <mat-icon class="material-icons-outlined">add_box</mat-icon>
      <span class="px-2 font-bold" i18n>Create filter</span>
    </button>
    <button (click)="resetForm()" mat-flat-button class="button-secondary" *ngIf="!callFromDialog">
      <mat-icon class="material-icons-outlined">close</mat-icon>
      <span class="px-2 font-bold" i18n>Reset all</span>
    </button>
    <!-- Button to show only on filter Dialog to create tabs -->
    <button (click)="filterData()" mat-flat-button class="button-primary" *ngIf="callFromDialog">
      <mat-icon iconPositionEnd class="material-icons-outlined">send</mat-icon>
      <span class="px-2 font-bold" i18n>Create filter</span>
    </button>
  </div>
</div>
